/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileResponseDto } from './FileResponseDto';
export type ReportResponseDto = {
  /**
   * Unique identifier of the report
   */
  id: number;
  /**
   * Type of the report
   */
  type: ReportResponseDto.type;
  /**
   * Current status of the report
   */
  status: ReportResponseDto.status;
  /**
   * Error message if the report generation failed
   */
  error?: string;
  /**
   * Output format of the report
   */
  format: ReportResponseDto.format;
  /**
   * File details if the report is available
   */
  file?: FileResponseDto;
  /**
   * Report parameters used for generation
   */
  parameters: any;
  /**
   * Timestamp when the report was created
   */
  createdAt: string;
  /**
   * Timestamp when the report was last updated
   */
  updatedAt: string;
};
export namespace ReportResponseDto {
  /**
   * Type of the report
   */
  export enum type {
    DEVICE_TELEMETRY = 'DEVICE_TELEMETRY',
  }
  /**
   * Current status of the report
   */
  export enum status {
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
  }
  /**
   * Output format of the report
   */
  export enum format {
    CSV = 'CSV',
    XLSX = 'XLSX',
  }
}

